import image1 from "../assets/img/portfolio/portfolio-1.jpg";
import image2 from "../assets/img/portfolio/portfolio-2.jpg";
import image3 from "../assets/img/portfolio/portfolio-3.jpg";
import image4 from "../assets/img/portfolio/portfolio-4.jpg";
import image5 from "../assets/img/portfolio/portfolio-5.jpg";
import image6 from "../assets/img/portfolio/portfolio-6.jpg";
import image7 from "../assets/img/portfolio/portfolio-7.jpg";
import image8 from "../assets/img/portfolio/portfolio-8.jpg";

const portfolioData = [
    {        
        id: 'community-center',
        title: 'Community Center',
        subtitle: 'Public Spaces',
        image: image1,
        category: "marketing",
    },
    {        
        id: 'healthcare-facility',
        title: 'Healthcare Facility',
        subtitle: 'Healthcare',
        image: image2,
        category: "corporate",
    },
    {        
        id: 'seaside-resort-expansion',
        title: 'Seaside Resort Expansion',
        subtitle: 'Hospitality',
        image: image3,
        category: "business",
    },
    {        
        id: 'urban-mall-development',
        title: 'Urban Mall Development',
        subtitle: 'Retail',
        image: image4,
        category: "marketing",
    },
    {        
        id: 'modern-architecture',
        title: 'Modern Architecture',
        subtitle: 'Modern',
        image: image5,
        category: "corporate",
    },
    {        
        id: 'industrial-warehouse',
        title: 'Industrial Warehouse',
        subtitle: 'Industrial',
        image: image6,
        category: "business",
    },
    {        
        id: 'luxury-home-renovation',
        title: 'Luxury Home Renovation',
        subtitle: 'Residential',
        image: image7,
        category: "corporate",
    },
    {        
        id: 'historic-restoration',
        title: 'Historic Restoration',
        subtitle: 'Renovation',
        image: image8,
        category: "business",
    },
];

export default portfolioData;
